import * as React from "react";
import { observer } from "mobx-react";

import { BaseDict } from "./dict";
import { HeaderRegulationRibbonMessageBlockData } from "./data";
import { RibbonMessage, RibbonButton } from "./components";

/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the HeaderRegulationRibbonHeaderRegulationRibbonBlock component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

@observer
export class HeaderRegulationRibbonMessageBlock extends React.Component<{
    dataProvider: HeaderRegulationRibbonMessageBlockData,
    dict: BaseDict<string>,
    cms: any
}, {
    dataProvider: HeaderRegulationRibbonMessageBlockData
}> {
    dict: BaseDict<string>;
    cms: any;
    message: string;

    constructor(props) {
        super(props);

        // setup dictionary
        this.dict = this.props.dict;
        // setup cms
        this.cms = this.props.cms;
        this.message = this.cms.Message;

        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        }
    }

    renderButton() {
        return <RibbonButton
            text={this.dict[this.state.dataProvider.chooseBtnText]}
            handler={this.state.dataProvider.changeExpanded}
            modifier={this.state.dataProvider.chooseModifier} />;
    }

    /* istanbul ignore next */
    render() {
        const expandedClass = this.state.dataProvider.isExpanded ? "" : "not-expanded";
        const isHiddenClass = this.state.dataProvider.shouldHide && this.message === "" ? "isHidden" : "";
        const message = this.getMessageText();

        return (
            <div className={`rj-ribbon__main-container ${isHiddenClass}`}>
                <RibbonMessage
                    className={`rj-ribbon__message ${expandedClass}`}
                    handler={this.state.dataProvider.changeExpanded}
                    message={message}
                    resizeHandler={this.state.dataProvider.winResizeHandler}
                />
                {this.state.dataProvider.hasButton === true && this.renderButton()}
            </div>
        );
    }

    getMessageText()
    {
        if (this.message){
            return this.message;
        }
        else{
            return this.state.dataProvider.message.messageText
        }
    }

}
